<template>
	<grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_POS)"
        :canDelete="checkClaim(CAN_DELETE_POS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :handleRowClick="onRowClick"
      />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
// import { debounce, unionBy } from 'lodash';

import { dateTime, date } from '@/shared/filters';
import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';

import gridFields from './fields';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
	components: {
		GridSettings,
		GridComponent
	},
	props: {
		purchaseOrderId: {
			type: [String, Number],
			default: 0
		},
		isFilteredList: {
			type: Boolean,
			default: false
		},
		purchaseOrderSchedulesFiltered: {
			type: Array,
			default: () => []
		},
    gridId: {
      type: String,
      default: GRID_ID.PURCHASE_ORDER_LINE_SCHEDULES
    }
	},
	data() {
		return {
			prepareColumnsData,
			// take: PAGE_SIZE,
			fields: gridFields,
      selectedRowItemId: 0,
		};
	},
	computed: {
		...mapGetters('purchaseorderlineschedules', [ 'purchaseOrderLineSchedulesList' ]),
		...mapGetters('account', ['gridSettingsById']),
		itemData() {
			const listItems = this.isFilteredList ? this.purchaseOrderSchedulesFiltered : this.purchaseOrderLineSchedulesList;

			if(listItems == undefined || listItems.length === 0) return [];
			return listItems.map((PurchaseOrderLineSchedules) => ({ ...PurchaseOrderLineSchedules, selected: PurchaseOrderLineSchedules.id === this.selectedRowItemId }));
		},
		gridSettings() {
			return this.gridSettingsById(this.gridId);
		},
	},
	filters: {
		dateTime,
		date
	},
	methods: {
		// ...mapMutations('purchaseorderlineschedules', [ 'setPurchaseOrderLineSchedulesList' ]),
		// ...mapActions('purchaseorderlineschedules', [ 'getSchedulesByPurchaseOrderId' ]),
		onRowClick(e) {
			this.selectedRowItemId = e.dataItem.id;
			this.$emit('selectedPOSchedule', e.dataItem);
		}
	},
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#PurchaseOrderLineSchedules-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
}

#PurchaseOrderLineSchedules-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}


.PurchaseOrderLineSchedules {
  &--PurchaseOrderLineSchedules-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }

    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
	min-width: 800px;
}
</style>
